/* EOOQI v2. Dawn refreshes only the chosen variant; no full variant list is serialized. */
if (!customElements.get('eooqi-purchase')) {
  customElements.define('eooqi-purchase', class extends HTMLElement {
    beginUpdate() {
      if (!this.hasAttribute('data-state')) this.keepDirectOpen = this.querySelector('details.eooqi-direct')?.open === true;
      this.setAttribute('data-state', 'loading');
      this.setAttribute('aria-busy', 'true');
      this.disableOldContent();
      this.setStatus(this.dataset.loadingLabel);
    }

    disableOldContent() {
      const content = this.querySelector('[data-eooqi-content]');
      if (content) { content.hidden = true; content.setAttribute('inert', ''); }
      // Remove the old target too: an in-flight selection must never send the previous variant.
      this.querySelectorAll('[data-eooqi-amazon]').forEach((link) => {
        link.removeAttribute('href');
        link.setAttribute('aria-disabled', 'true');
      });
    }

    setStatus(message) {
      const status = this.querySelector('[data-eooqi-status]');
      if (status) { status.hidden = false; status.textContent = message || ''; }
    }

    showError() {
      this.setAttribute('data-state', 'error');
      this.removeAttribute('aria-busy');
      this.disableOldContent();
      this.setStatus(this.dataset.errorLabel);
    }

    syncFrom(html, sectionId) {
      const source = html.getElementById(`EooqiPurchase-${sectionId}`);
      if (!source) { this.showError(); return; }
      const keepOpen = this.keepDirectOpen ?? this.querySelector('details.eooqi-direct')?.open;
      // Use the same parsed-HTML insertion pattern as Dawn so native product-form
      // upgrades after its form and inputs have been parsed.
      this.innerHTML = source.innerHTML;
      this.dataset.variantId = source.dataset.variantId || '';
      this.dataset.loadingLabel = source.dataset.loadingLabel;
      this.dataset.errorLabel = source.dataset.errorLabel;
      this.removeAttribute('data-state');
      this.removeAttribute('aria-busy');
      const direct = this.querySelector('details.eooqi-direct');
      if (direct && keepOpen) direct.open = true;
      this.keepDirectOpen = undefined;
    }
  });
}

(() => {
  'use strict';
  if (window.__eooqiAmazonFunnelInstalled) return;
  window.__eooqiAmazonFunnelInstalled = true;
  window.__eooqiAmazonClickInstalled = true;

  const attributionRoutes = Object.freeze([
  {
    "campaign": "PET POOL 32-48",
    "group": "PET POOL 32-48 Google Ads 01",
    "url": "https://www.amazon.com/dp/B0BP2GLCD3?maas=maas_adg_E83C1D837EC25D7028124DC8E6ABB89C_afap_abs&ref_=aa_maas&tag=maas",
    "asin": "B0BP2GLCD3"
  },
  {
    "campaign": "PET POOL 32-48",
    "group": "PET POOL 32-48 Google Ads  02",
    "url": "https://www.amazon.com/dp/B0BP2GLCD3?maas=maas_adg_FF066B318EEE0A3FF2DFD80838AE46EE_afap_abs&ref_=aa_maas&tag=maas",
    "asin": "B0BP2GLCD3"
  },
  {
    "campaign": "PET POOL 55-71",
    "group": "PET POOL 55-71 Google Ads",
    "url": "https://www.amazon.com/dp/B0BP2631KJ?maas=maas_adg_FF84172B5DDF0500715E16BBBA2559CC_afap_abs&ref_=aa_maas&tag=maas",
    "asin": "B0BP2631KJ"
  },
  {
    "campaign": "PET POOL 79-97",
    "group": "PET POOL 55-71 Google Ads",
    "url": "https://www.amazon.com/dp/B0F9YT4XKW?maas=maas_adg_F23A6DA6F3EAEB1455CD7697D686CD06_afap_abs&ref_=aa_maas&tag=maas",
    "asin": "B0F9YT4XKW"
  },
  {
    "campaign": "PET POOL 19",
    "group": "PET POOL 19 Google Ads",
    "url": "https://www.amazon.com/dp/B0GKNCZ2NS?maas=maas_adg_45A9B3ED006FE73E08E56C4D1EA27F51_afap_abs&ref_=aa_maas&tag=maas",
    "asin": "B0GKNCZ2NS"
  },
  {
    "campaign": "L Beige and Coffee",
    "group": "L Beige and Coffee Google Ads",
    "url": "https://www.amazon.com/dp/B0BQ3MFZ2H?maas=maas_adg_80697D07A95834FEF88B88885D4CF60B_afap_abs&ref_=aa_maas&tag=maas",
    "asin": "B0BQ3MFZ2H"
  },
  {
    "campaign": "L  Dark Gray",
    "group": "L  Dark Gray Google Ads",
    "url": "https://www.amazon.com/dp/B0D7ZKG5VX?maas=maas_adg_00806C3FE8126EC5C82C52B2A107C06E_afap_abs&ref_=aa_maas&tag=maas",
    "asin": "B0D7ZKG5VX"
  },
  {
    "campaign": "L  Light Gray",
    "group": "L  Light Gray Google Ads",
    "url": "https://www.amazon.com/dp/B0GXWFR1WK?maas=maas_adg_757499754778DB3F45C930854984AD7A_afap_abs&ref_=aa_maas&tag=maas",
    "asin": "B0GXWFR1WK"
  },
  {
    "campaign": "L  Black",
    "group": "L  Black Google Ads",
    "url": "https://www.amazon.com/dp/B0GXWBKJGB?maas=maas_adg_98B0B35342F3511AC9A9F6CEDC745C86_afap_abs&ref_=aa_maas&tag=maas",
    "asin": "B0GXWBKJGB"
  },
  {
    "campaign": "A6 Off-white and Coffee",
    "group": "A6 Off-white and Coffee Google Ads",
    "url": "https://www.amazon.com/dp/B0DHZHPL8V?maas=maas_adg_4FF34E7C3DECE38324B199B54FAECAAB_afap_abs&ref_=aa_maas&tag=maas",
    "asin": "B0DHZHPL8V"
  },
  {
    "campaign": "A6 Green+light Gray",
    "group": "A6 Green+light Gray Google Ads",
    "url": "https://www.amazon.com/dp/B0GHYLYS4N?maas=maas_adg_0B597E7AD8E73968FD2B473D098C3BF2_afap_abs&ref_=aa_maas&tag=maas",
    "asin": "B0GHYLYS4N"
  },
  {
    "campaign": "A5  Dark Gray",
    "group": "A5  Dark Gray Google Ads",
    "url": "https://www.amazon.com/dp/B0DHZJK76R?maas=maas_adg_124A9558D5D0CD1D9955B2ED3B33284D_afap_abs&ref_=aa_maas&tag=maas",
    "asin": "B0DHZJK76R"
  },
  {
    "campaign": "A3  Dark Blue",
    "group": "A3  Dark Blue Google Ads",
    "url": "https://www.amazon.com/dp/B0DHZFFJYJ?maas=maas_adg_43DBAE0371758CA82936114FCB17FE7F_afap_abs&ref_=aa_maas&tag=maas",
    "asin": "B0DHZFFJYJ"
  },
  {
    "campaign": "A3 Off-white and Light Gray",
    "group": "A3 Off-white and Light Gray Google Ads",
    "url": "https://www.amazon.com/dp/B0DHZH1TFF?maas=maas_adg_8CA2E117A94EB2B1964C0148CDCC4910_afap_abs&ref_=aa_maas&tag=maas",
    "asin": "B0DHZH1TFF"
  }
]);
  const storageKey = 'eooqi-google-amazon-v2';
  const lifetime = 30 * 60 * 1000;
  const analyticsAllowed = () => {
    try {
      return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
    } catch {
      return false;
    }
  };
  const clearStored = () => {
    try { sessionStorage.removeItem(storageKey); } catch {}
  };
  const findRoute = (campaign, group) => attributionRoutes.find(row => row.campaign === campaign && row.group === group) || null;
  const readContext = () => {
    const params = new URL(window.location.href).searchParams;
    const source = (params.get('utm_source') || '').toLowerCase();
    const medium = (params.get('utm_medium') || '').toLowerCase();
    if (source === 'google' && medium === 'cpc') {
      const match = findRoute(params.get('utm_campaign'), params.get('utm_content'));
      if (match) return match;
    }
    const explicitSource = [...params.keys()].some(key => key.startsWith('utm_') || ['gclid', 'gbraid', 'wbraid'].includes(key));
    let internal = false;
    try { internal = new URL(document.referrer).origin === window.location.origin; } catch {}
    if (!explicitSource && internal && analyticsAllowed()) {
      try {
        const saved = JSON.parse(sessionStorage.getItem(storageKey));
        const match = findRoute(saved?.campaign, saved?.group);
        if (match && Number.isFinite(saved.expires) && saved.expires > Date.now() && saved.expires <= Date.now() + lifetime) return match;
      } catch {}
    }
    clearStored();
    return null;
  };
  let context = readContext();
  const saveContext = () => {
    if (!context || !analyticsAllowed()) { clearStored(); return; }
    try { sessionStorage.setItem(storageKey, JSON.stringify({ campaign: context.campaign, group: context.group, expires: Date.now() + lifetime })); } catch {}
  };
  saveContext();
  const decorate = link => window.EooqiAmazonLinks?.decorate(link, context);
  const scan = () => { window.EooqiAmazonLinks?.setGoogleContext(context); };
  let scheduled = false;
  const scheduleScan = () => {
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(() => { scheduled = false; scan(); });
  };
  scan();
  const observer = new MutationObserver(scheduleScan);
  observer.observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['href', 'aria-disabled', 'data-market'] });
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('visitorConsentCollected', () => { saveContext(); scan(); });
  window.addEventListener('pageshow', () => { context = readContext(); saveContext(); scan(); });
  window.addEventListener('popstate', () => { context = readContext(); saveContext(); scan(); });

  const recordClick = event => {
    if (event.type === 'auxclick' && event.button !== 1) return;
    const link = event.target instanceof Element ? event.target.closest('a[data-eooqi-amazon]') : null;
    if (!link || event.defaultPrevented || !link.hasAttribute('href') || link.getAttribute('aria-disabled') === 'true') return;
    decorate(link);
    if (!analyticsAllowed() || !Array.isArray(window.dataLayer)) return;
    try {
      const destination = new URL(link.href);
      const expectedHosts = link.dataset.market === 'DE' ? ['amazon.de', 'www.amazon.de'] : ['amazon.com', 'www.amazon.com'];
      if (destination.protocol !== 'https:' || !expectedHosts.includes(destination.hostname) || destination.username || destination.password) return;
      const destinationAsin = destination.pathname.match(/^\/(?:dp|gp\/product)\/([A-Z0-9]{10})(?:\/|$)/i)?.[1]?.toUpperCase() || '';
      window.dataLayer.push({
        event: 'eooqi_amazon_click',
        button_placement: link.dataset.eooqiPlacement || 'other',
        viewport_type: window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop',
        amazon_market: link.dataset.market,
        product_id: link.dataset.productId,
        variant_id: link.dataset.variantId,
        product_handle: link.dataset.productHandle,
        amazon_asin: destinationAsin,
        google_ad_group: link.dataset.eooqiAttributionGroup || '',
        attribution_campaign: link.dataset.eooqiAttributionCampaign || '',
        amazon_attribution_applied: link.dataset.eooqiAttributionApplied === 'true',
        amazon_link_mode: link.dataset.eooqiLinkMode || '',
        amazon_routing_source: window.EooqiAmazonLinks?.getRoutingSource() || '',
        destination_path: destination.pathname
      });
    } catch {}
  };
  document.addEventListener('click', recordClick);
  document.addEventListener('auxclick', recordClick);
})();


